import React from 'react';
import AlmeInput from '../AlmeInput/AlmeInput';
import styled from 'styled-components';
const Container = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 15px 2px 15px;
    border-top: 1px solid #cccccc;
    background-color: #e6e6e6;
`;
const AlmeFooter = (props) => {
    return (React.createElement(Container, null,
        React.createElement(AlmeInput, { almeAppConfig: props.almeAppConfig, submitFunc: props.submitFunc, focusProps: props.focusProps, isLiveChatConnected: props.isLiveChatConnected, onSendTypingEvent: props.onSendTypingEvent })));
};
export default AlmeFooter;
